import {createRedux} from '../../../redux/factories/common/reduxFactory';
import {LIST_GROUP_OPTIONS, LIST_GROUP_OPTIONS_FAILED, LIST_GROUP_OPTIONS_SUCCESS} from "./constants";

const {actionTypes, actions} = createRedux([
    'listGroupPermission',
    'updateUserInGroup',
    'downloadGroups',
    LIST_GROUP_OPTIONS,
    LIST_GROUP_OPTIONS_SUCCESS,
    LIST_GROUP_OPTIONS_FAILED
]);

const INIT_STATE = {
    loading: false,
    options: [],
};

const groupReducers = (state = INIT_STATE, action) => {
    if (Object.values(actionTypes).indexOf(action.type) === -1) {
        return {...state};
    }

    if (action.type === actionTypes['downloadGroups']) {
        return {...state, loading: true};
    } else if (action.type === actionTypes['downloadGroupsSuccess']) {
        return {...state, loading: false};
    } else if (action.type === actionTypes['downloadGroupsFailed']) {
        return {...state, loading: false};
    }

    if (action.type === actionTypes['listGroupPermission']) {
        return {...state, loading: true};
    } else if (action.type === actionTypes['listGroupPermissionSuccess']) {
        const permission = action.payload.result;
        return {...state, loading: false, permission};
    } else if (action.type === actionTypes['listGroupPermissionFailed']) {
        return {...state, loading: false};
    }

    if (action.type === actionTypes['updateUserInGroup']) {
        return {...state, loading: true};
    } else if (action.type === actionTypes['updateUserInGroupSuccess']) {
        return {...state, loading: false};
    } else if (action.type === actionTypes['updateUserInGroupFailed']) {
        return {...state, loading: false};
    }

    if (action.type === actionTypes[LIST_GROUP_OPTIONS]) {
        return {...state, loading: true};
    } else if (action.type === actionTypes[LIST_GROUP_OPTIONS_SUCCESS]) {
        return {...state, loading: false, options: action.payload};
    } else if (action.type === actionTypes[LIST_GROUP_OPTIONS_FAILED]) {
        return {...state, loading: false};
    }
};

export {actions, actionTypes, groupReducers};
